// src/components/Staff.js
import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';
import useReveal from '../hooks/useReveal';
import Modal from './Modal';

const INITIAL_VISIBLE = 4;

function Staff() {
  const sectionRef = useReveal();
  const [staff, setStaff] = useState([]);
  const [visibleCount, setVisibleCount] = useState(INITIAL_VISIBLE);
  const [selectedStaff, setSelectedStaff] = useState(null);

  useEffect(() => {
    const fetchStaff = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'staff'));
        const staffList = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setStaff(staffList);
      } catch (error) {
        console.error('ข้อผิดพลาดในการดึงข้อมูลจาก Firestore: ', error);
      }
    };

    fetchStaff();
  }, []);

  if (staff.length === 0) {
    return null;
  }

  const isExpanded = visibleCount > INITIAL_VISIBLE;

  return (
    <section id="staff" className="reveal" ref={sectionRef}>
      <div className="section-content">
        <span className="section-eyebrow">Our Team</span>
        <h2 className="section-title">แนะนำทีมงาน</h2>
        <p className="section-lead">
          ทีมงานที่มีประสบการณ์และเอาใจใส่ เราให้ความสำคัญกับสุขภาพและความเป็นอยู่ที่ดีของสัตว์เลี้ยง
        </p>
        <div className="staff-grid">
          {staff.slice(0, visibleCount).map((member) => (
            <div key={member.id} className="staff-member">
              <img src={member.photoURL} alt={member.name} loading="lazy" />
              <h3>{member.name}</h3>
              <p>{member.position}</p>
              <button type="button" onClick={() => setSelectedStaff(member)}>
                ดูรายละเอียด
              </button>
            </div>
          ))}
        </div>
        {visibleCount < staff.length && (
          <div className="more-button-container">
            <button
              type="button"
              onClick={() => setVisibleCount((count) => count + INITIAL_VISIBLE)}
              className="more-button"
            >
              ดูเพิ่มเติม
            </button>
          </div>
        )}
        {isExpanded && visibleCount >= staff.length && (
          <div className="more-button-container">
            <button
              type="button"
              onClick={() => setVisibleCount(INITIAL_VISIBLE)}
              className="more-button"
            >
              ปิด
            </button>
          </div>
        )}
      </div>

      {selectedStaff && (
        <Modal onClose={() => setSelectedStaff(null)} label={selectedStaff.name} variant="modal-staff">
          <img src={selectedStaff.photoURL} alt={selectedStaff.name} />
          <h2>{selectedStaff.name}</h2>
          <h4>{selectedStaff.position}</h4>
          <p>{selectedStaff.bio}</p>
        </Modal>
      )}
    </section>
  );
}

export default Staff;
